import {
  Box,
  Button,
  FormControl,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react"
import * as React from "react"
import { toast } from "react-toastify"
import { navigate } from "gatsby-link"
import { AuthHeader, AuthButton, inputStyles } from "./AuthHeader"
import { colors } from "../colors/colors"
import { getApiUrl, setUserId, setUserVerified } from "../../utils/loginInfo"
import { usePurchasingCTAs } from "./usePurchasingCTAs"

export function Signup({ fontFamily = "Lato", clickableColor, buttonColor, buttonTextColor, buttonHoverColor, buttonTextHoverColor, title, cta }) {
  const { signup } = usePurchasingCTAs()

  return (
    <>
      <AuthHeader
        title={title || "SIGN UP"}
        subText="Already have an account?"
        subCtaLink={signup?.link}
        subCta={signup?.linkCta}
        fontFamily={fontFamily}
        clickableColor={clickableColor}
      />

      <Box maxW={{ base: `100%` }} m="30px auto 0">
        <SignupForm fontFamily={fontFamily} clickableColor={clickableColor} buttonColor={buttonColor} buttonTextColor={buttonTextColor} buttonHover={{background: buttonHoverColor || '#CEFF1A', color: buttonTextHoverColor || 'rgba(128,0,255,1)'}} submitCTA={cta} />
      </Box>
    </>
  )
}

export function SignupForm({ fontFamily, clickableColor, buttonColor, buttonTextColor, buttonHover, submitCTA }) {
  const { products, signup } = usePurchasingCTAs()
  const [showPassword, setShowPassword] = React.useState(false)

  const handleShowClick = () => setShowPassword(!showPassword)

  const [email, setEmail] = React.useState("")
  const [password, setPassword] = React.useState("")
  const [firstName, setFirstName] = React.useState("")
  const [lastName, setLastName] = React.useState("")

  const submitForm = () => {
    const requiredVals = {
      Email: email,
      "First Name": firstName,
      "Last Name": lastName,
      Password: password,
    }

    Object.entries(requiredVals).forEach(([field, val]) => {
      if (!val) {
        return toast.error(`${field} is required`, {
          hideProgressBar: true,
        })
      }
    })

    if (email && firstName && lastName && password) {
      const analyticsFlowName = location?.pathname?.replace('/', '');
      fetch(`${getApiUrl()}/user/sign_up?analyticsFlowName=${analyticsFlowName}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-M-P": "3",
        },
        body: JSON.stringify({
          email: email,
          givenName: firstName,
          familyName: lastName,
          password: password,
        }),
      })
        .then(res => {
          return res.json()
        })
        .then(response => {
          if (response) {
            if (response?.title) {
              return toast.error(response?.title, {
                hideProgressBar: true,
              })
            }

            if (response?.user?.id) {
              setUserId(response?.user?.id)
              setUserVerified(response?.user?.isVerified)
            }

            navigate(products?.link)
          } else {
            console.log("Email already in use")
          }
        })
    }
  }

  return (
    <form
      id="signup-form"
      onSubmit={event => {
        event.preventDefault()
        submitForm()
      }}
    >
      <Stack spacing={4}>
        <FormControl>
          <InputGroup>
            <Input
              type={"text"}
              placeholder="First Name"
              value={firstName}
              onChange={event => setFirstName(event.target.value)}
              {...inputStyles}
              fontFamily={fontFamily}
            />
          </InputGroup>
        </FormControl>
        <FormControl>
          <InputGroup>
            <Input
              type={"text"}
              placeholder="Last Name"
              value={lastName}
              onChange={event => setLastName(event.target.value)}
              {...inputStyles}
              fontFamily={fontFamily}
            />
          </InputGroup>
        </FormControl>
        <FormControl>
          <InputGroup>
            <Input
              type="email"
              placeholder="Email"
              onBlur={e => {
                if (
                  e.currentTarget?.value &&
                  !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
                    e.currentTarget?.value
                  )
                ) {
                  return toast.error(`Valid Email required`, {
                    hideProgressBar: true,
                  })
                }
              }}
              value={email}
              onChange={event => setEmail(event.target.value)}
              {...inputStyles}
              fontFamily={fontFamily}
            />
          </InputGroup>
        </FormControl>
        <FormControl>
          <InputGroup>
            <Input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={event => setPassword(event.target.value)}
              {...inputStyles}
              fontFamily={fontFamily}
            />
            <InputRightElement width="4.5rem" top="3px">
              <Button
                h="1.75rem"
                size="sm"
                color="#AEAEB2"
                bg="none"
                onClick={handleShowClick}
                fontFamily={fontFamily}
              >
                {showPassword ? "Hide" : "Show"}
              </Button>
            </InputRightElement>
          </InputGroup>
        </FormControl>
        <AuthButton label={submitCTA || signup?.buttonText} buttonColor={buttonColor} buttonTextColor={buttonTextColor} buttonHover={buttonHover} />
        <Box>
          <Text
            fontSize="13px"
            lineHeight="18px"
            color="#AEAEB2"
            letterSpacing="-0.21px"
            textAlign="center"
            m="0"
            fontFamily={fontFamily}
          >
            By submitting your information you agree to our <br />
            <Link color={clickableColor || colors.blue} href="/terms" target="_blank">
              Terms & Conditions
            </Link>{" "}
            and{" "}
            <Link color={clickableColor || colors.blue} href="/privacy" target="_blank">
              Privacy Policy
            </Link>
          </Text>
        </Box>
      </Stack>
    </form>
  )
}
